import { render } from "./CourseRegisteredCard.vue?vue&type=template&id=170752dd&scoped=true"
import script from "./CourseRegisteredCard.vue?vue&type=script&lang=js"
export * from "./CourseRegisteredCard.vue?vue&type=script&lang=js"

import "./CourseRegisteredCard.vue?vue&type=style&index=0&id=170752dd&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-170752dd"]])

export default __exports__